export const baseURL = process.env.REACT_APP_BASEURL || "https://api.example.com";